/* This file is autogenerated, see readme.md for instructions */
import SortSvgIcon from '@bloomreach/banana-theme/icons/sort.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const SortIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SortSvgIcon />
    </Icon>
  );
});

SortIcon.displayName = 'SortIcon';

export default SortIcon;
